// src/components/NavigationBar.js
import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../images/logo.jpg';
import './NavigationBar.css';
import './NavigationBarDropdown.css';

export default function NavigationBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const [aboutOpen, setAboutOpen] = useState(false);
  const aboutRef = useRef(null);

  // Ferme le sous-menu "À propos" si on clique en dehors (sur un lien du
  // sous-menu, ou n'importe où ailleurs sur la page)
  useEffect(() => {
    const onClickOutside = (e) => {
      if (aboutRef.current && !aboutRef.current.contains(e.target)) {
        setAboutOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const isAboutActive = location.pathname.startsWith('/apropos');

  const buttonsBeforeAbout = [
    { label: t('menu.home'), path: '/' },
    { label: t('menu.news'), path: '/actualites' },
    { label: t('menu.projects'), path: '/projets' },
  ];

  const buttonsAfterAbout = [
    { label: t('menu.contact'), path: '/contact' },
  ];

  const goTo = (path) => {
    navigate(path);
    setAboutOpen(false);
  };

  return (
    <div className="nav-bar">
      <div className="nav-brand">
        <img src={logo} alt="Logo DIBADAN" className="logo" />
        <div className="nav-brand-text">
          <span className="nav-brand-line1">Diaspora Bakong d'Amérique du Nord</span>
          <span className="nav-brand-line2">(DIBADAN)</span>
        </div>
      </div>

      <div className="nav-buttons">
        {buttonsBeforeAbout.map((btn) => (
          <button
            key={btn.path}
            onClick={() => navigate(btn.path)}
            className={`nav-button ${location.pathname === btn.path ? 'active' : ''}`}
          >
            {btn.label}
          </button>
        ))}

        {/* Bouton "À propos" avec menu déroulant (Bureau Exécutif / Commission d'eau).
            S'ouvre et se ferme uniquement au clic : sur le bouton lui-même,
            sur un des deux liens, ou n'importe où ailleurs (clic extérieur). */}
        <div className="nav-dropdown" ref={aboutRef}>
          <button
            type="button"
            className={`nav-button nav-dropdown-trigger ${isAboutActive ? 'active' : ''}`}
            aria-haspopup="true"
            aria-expanded={aboutOpen}
            onClick={() => setAboutOpen((o) => !o)}
          >
            {t('menu.about')}
            <span className="nav-dropdown-arrow" aria-hidden="true">▾</span>
          </button>

          {aboutOpen && (
            <div className="nav-dropdown-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className={`nav-dropdown-item ${location.pathname === '/apropos' ? 'active' : ''}`}
                onClick={() => goTo('/apropos')}
              >
                {t('menu.aboutBureau')}
              </button>
              <button
                type="button"
                role="menuitem"
                className={`nav-dropdown-item ${location.pathname === '/apropos/commission-eau' ? 'active' : ''}`}
                onClick={() => goTo('/apropos/commission-eau')}
              >
                {t('menu.aboutCommission')}
              </button>
            </div>
          )}
        </div>

        {buttonsAfterAbout.map((btn) => (
          <button
            key={btn.path}
            onClick={() => navigate(btn.path)}
            className={`nav-button ${location.pathname === btn.path ? 'active' : ''}`}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}
